
// !!!!!!!!!!!!!!!!! 
// !! Please don't add anything else to this file.  This is not the way to do things in a proper Vue app.
// !! Create new vue components instead, and put stand-alone functions in utils.js
//!!!!!!!!!!!!!!!!!
//! ls_utils.js
//! version : 0.1.1
//! author : Shaw + Scott Labs
//! requires : jquery and knockout
(function(window){
  'use strict';

  function ls_Utils() {

    var _lsUtil = {};
    
    var pwdVue = null;
    var alertVue = null;
    var statusVue = null;
    
    _lsUtil.changePassword = function(confirmOnSave, callBack) {
      if ($('#divChangePwd').length) {
          pwdVue.showPasswordChange();
      } else {
        $("body").append("<div></div>");
        $( "body div" ).last().load( "assets/pwd_change.html", function() {
          _lsUtil.initializePwdVue()
          pwdVue.showPasswordChange();
          if (confirmOnSave) {
            pwdVue.password.confirmOnSave = confirmOnSave;
          } else {
            pwdVue.password.confirmOnSave = false;            
          }
          if (callBack) {
            pwdVue.password.callBack = callBack;            
          } else {
            pwdVue.password.callBack = null;            
          }
        } );
      }

    }
    
    _lsUtil.initializePwdVue = function () {
      
      pwdVue = new Vue({
        delimiters: ['${', '}'],
        el: '#divChangePwd',
        data: {
          password: {
            pwdRules : 'Password cannot contain spaces and must include a minumum of 8 characters, a combination of upper and lowercase letters, and at least one number',
            pwdError : false,
            pwdErrorMsg : '',
            existingPwd : '',
            newPwd : '',
            confirmPwd : '',
            confirmOnSave: false,
            callBack: null
          }
        },
        mounted: function() {
          $('#divChangePwd').on('shown.bs.modal', function() {$('#old_password').focus()});
        },
        methods: {
          showPasswordChange: function() {
            this.password.pwdError = false;
            this.password.pwdErrorMsg = '';
            this.password.existingPwd = '';
            this.password.newPwd = '';
            this.password.confirmPwd = '';
            $('#divChangePwd').modal('show');
          },
          checkPassword: function(str) {
            if (str.indexOf(' ')>=0) {
              return false;
            }
            return str.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d!@#$%^&*()_+]{8,}$/);
          },
          validatePassword: function() {
            if (this.password.existingPwd == '') {
              this.password.pwdError = true;
              this.password.pwdErrorMsg = 'No value entered for current password';
              return false;
            } else if (this.password.newPwd == '') {
              this.password.pwdError = true;
              this.password.pwdErrorMsg = 'No value entered for new password';
              return false;
            } else if(this.password.newPwd!=='' && this.password.newPwd==this.password.confirmPwd) {
              if(!this.checkPassword(this.password.newPwd)) {
                this.password.pwdError = true;
                this.password.pwdErrorMsg = this.password.pwdRules;
                return false;
              } else {
                return true;
              }
            } else if (this.password.newPwd!=this.password.confirmPwd) {
              this.password.pwdError = true;
              this.password.pwdErrorMsg = "Passwords do not match - please ensure both password values are the same";
              return false;
            } else {
              return true;
            }
          },
          changePwd: function() {

            //save new password
            var user = {};
            var cancelPropigation = true; // pass value back out to calling DOM object 
            user.password = this.password.existingPwd;
            user.new_password = this.password.newPwd;
            if (!this.validatePassword()) {
              return cancelPropigation; 
            }
            $.ajax({
                type: "POST",
                url: '/change-password',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(user),
                dataType: 'json',
                success: function(data){
                  pwdVue.password.pwdError = true;
                  pwdVue.password.pwdErrorMsg = '';
                  pwdVue.password.existingPwd = '';
                  pwdVue.password.newPwd = '';
                  pwdVue.password.confirmPwd = '';
                  cancelPropigation = false;
                  $('#divChangePwd').modal('hide');
                  
                  if (pwdVue.password.confirmOnSave) {
                    setTimeout(function(){_lsUtil.alert('Password successfully changed','Password Changed')},250)
                  }
                  return cancelPropigation;
                },
                error: function(xhr,textStatus,errorThrown){
                  pwdVue.password.pwdError = true;
                  if (xhr.status == 401){
                    pwdVue.password.pwdErrorMsg="Your current password is incorrect.  Please try again.";
                  } else if (xhr.status == 400 && xhr.responseJSON.message == 'Password in use') {
                    pwdVue.password.pwdErrorMsg='New password cannot be the same as current password. Please enter a different value for new password.'
                  } else {
                    pwdVue.password.pwdErrorMsg=xhr.responseText;
                  }
                  cancelPropigation = true;
                  console.log("Response: " + xhr.responseText);
                  return cancelPropigation;

                }
            });

            if (true) {
            } else {
            }
            return cancelPropigation;
          }
        },
        computed: {
          validPassword: function() {
            return this.password.newPwd.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d!@#$%^&*()_+]{8,}$/);
          },
          passwordMatches: function() {
            return (this.password.newPwd==this.password.confirmPwd && this.password.newPwd.length>0);
          }
        }
      });
                  
    }    

    _lsUtil.nullToString = function(value) {
      return (value == null) ? '' : value;
    }
    
    _lsUtil.firstChar = function(item){
      return item.toString().substring(0,1).toUpperCase();
    }

    _lsUtil.formatNulls = function(item) {
      if (item) {
        return item;
      } else {
        return 0;
      }
    }

    _lsUtil.formatNumber = function(num) {
      var a = String(num);

      return a.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

    }

    _lsUtil.pad = function (n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }
    
    _lsUtil.validateForm = function(frm, resetValid) {
      var $inputs = $(frm + ' :input');
      var errorFlag = false;
      
      $inputs.each(function() {
        if ($(this).attr('required') && $(this).val().length==0) {
          $(this).parent().addClass('has-error');
          $(this).attr('placeholder', ($(this).data('label')) ? $(this).data('label') + ' is required' : 'Field is required');
          errorFlag = true;
        } else if ($(this).attr('required') && $(this).data('type')=='date' && !moment($(this).val()).isValid()) {
          $(this).parent().addClass('has-error');
          $(this).attr('placeholder', ($(this).data('label')) ? $(this).data('label') + ' is not a valid date' : 'Field is not a valid date');
          errorFlag = true;          
        } else if ($(this).attr('required') && $(this).data('validate')=='number' && isNaN($(this).val())) {
          $(this).parent().addClass('has-error');
          $(this).attr('placeholder', ($(this).data('label')) ? $(this).data('label') + ' is not a valid number' : 'Field is not a valid number');
          errorFlag = true;          
        } else if (resetValid) {
          $(this).parent().removeClass('has-error');
          $(this).attr('placeholder', ($(this).data('placeholder')) ? $(this).data('placeholder') : ($(this).data('label')) ? 'Enter value for ' + $(this).data('label') : 'Enter value for field');          
        }
      });
      
      return !errorFlag;

    }
    
    _lsUtil.resetPlaceholders = function(frm) {
      var $inputs = $(frm + ' :input');
      
      $inputs.each(function() {
        $(this).attr('placeholder', ($(this).data('placeholder')) ? $(this).data('placeholder') : ($(this).data('label')) ? 'Enter value for ' + $(this).data('label') : 'Enter value for field');
        if ($(this).attr('required')) {
          $(this).attr('changed','false');
          $(this).parent().removeClass('has-error');
          $(this).blur(function() {if ($(this).attr('required') && $(this).attr('changed')!='false') {_lsUtil.validateInput(this,'isempty'); return true;}});
          $(this).keyup(function(e) {if(e.keyCode==8 || e.keyCode==46){$(this).attr('changed','true');} if(($(this).val()) && $(this).val().length>0){$(this).attr('changed','true');_lsUtil.validateInput(this,'isempty')}});
        }
      });

    }

    _lsUtil.resetPlaceholders_v2 = function(frm) {
      var $inputs = $(frm + ' :input');
      $(frm).removeClass('has-error');
      
      $inputs.each(function() {
        $(this).attr('placeholder', ($(this).data('label')) ? 'Enter value for ' + $(this).data('label') : 'Enter value for field');
        if ($(this).data('validate')) {
          $(this).data('changed','false');
          $(this).parent().removeClass('has-error');
          
          $(this).blur(function() {
            if ($(this).attr('required') && $(this).data('changed')!='false') {
              _lsUtil.validateInput(this,$(this).data('validate')); return true;
            }
          });
                      
          $(this).on('change',function(e) {
              $(this).data('changed','true');
              //_lsUtil.validateInput(this,validation);
          });
            
        }
      });

    }
    
    _lsUtil.validateInput = function(input,validation,errorPlaceholder) {
      var label = ($(input).data('label')) ? $(input).data('label') : 'field';
      var val = $(input).val();
      var passed = true;
      
      switch (validation.toLowerCase()) {
        case 'isempty':
          if (val !== null && val.trim()!=='') {
            $(input).parent().removeClass('has-error');
            $(input).attr('placeholder', ($(input).data('placeholder')) ? $(input).data('placeholder') : 'Enter ' + label);
            passed = true;
          } else if (val == null || val.trim()=='') {
            $(input).parent().addClass('has-error');
            $(input).attr('placeholder', (errorPlaceholder) ? errorPlaceHolder : label + ' is required');
            passed = false;
          }
          break;
        case 'number':
          if (val !== null && !isNaN(val)) {
            $(input).parent().removeClass('has-error');
            $(input).attr('placeholder', ($(input).data('placeholder')) ? $(input).data('placeholder') : 'Enter ' + label);
            $(input).attr('placeholder', 'Enter ' + label);
            passed = true;
          } else if (val == null || val.trim()=='') {
            console.log('sleya');
            $(input).parent().addClass('has-error');
            $(input).attr('placeholder', (errorPlaceholder) ? errorPlaceHolder : label + ' must be a valid number');
            passed = false;
          }
          break;
        case 'email':
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          passed = re.test(val);
          if (!passed) {
            var origPlaceholder = $(input).attr('placeholder');
            $(input).parent().addClass('has-error');
            $(input).attr('placeholder',(errorPlaceholder) ? errorPlaceHolder : 'Enter a valid email');          
          } else {
            $(input).parent().removeClass('has-error');
            $(input).attr('placeholder', ($(input).data('placeholder')) ? $(input).data('placeholder') : 'Enter ' + label);            
          }
          break;
      }
      return passed;
    }

    _lsUtil.resetInput = function(input) {
      var errorFlag = false;
      
      if ($(input).attr('required') && $(input).val().length==0) {
        $(input).attr('placeholder', ($(input).data('label')) ? $(input).data('label') + ' is required' : 'Field is required');
        errorFlag = true;
      } else {
        $(input).parent().removeClass('has-error');
        $(input).attr('placeholder', ($(input).data('label')) ? 'Enter value for ' + $(input).data('label') : 'Enter value for field');
      }
      
      return !errorFlag;

    }
    
    
    _lsUtil.getItemsByKey = function(key, obj, keyName) {
      if (!(keyName)) keyName = 'key';
      
      var filteredItems = obj.filter(function(item){
        return item[keyName]==key;
      });
      
      return filteredItems;
    }
    
    _lsUtil.getIndexByKey = function(key, obj, keyName) {
      if (!(keyName)) keyName = 'key';
      for (var itm in obj) {
        if (obj[itm][keyName]==key) return itm;
      }
      return -1;
      
    }

    _lsUtil.urlParam = function(name){
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      if (results==null){
         return null;
      }
      else{
         return results[1] || 0;
      }
    }

    return _lsUtil;
  }
  // We need that our library is globally accesible, then we save in the window
  if(typeof(window.labsUtils) === 'undefined'){
    window.labsUtils = ls_Utils;
  }
})(window); 

 